import React from 'react';

const NotFound = () => <div>... nothing found here...</div>

export default NotFound;